import {
  createPlugin,
  createApiFactory,
  discoveryApiRef,
  identityApiRef,
} from "@backstage/core-plugin-api";
import { githubApiRef, GithubApi } from "./api/GithubApi";
import { rootRouteRef } from "./routes";

export const githubApiPlugin = createPlugin({
  id: "github-api",
  apis: [
    createApiFactory({
      api: githubApiRef,
      deps: {
        discoveryApi: discoveryApiRef,
        identityApi: identityApiRef,
      },
      factory: ({ discoveryApi, identityApi }) =>
        new GithubApi({
          identityApi,
          discoveryApi,
        }),
    }),
  ],
  routes: {
    root: rootRouteRef,
  },
});
